import React, { useState } from 'react';
import { BookOpenCheck, ChevronDown, ChevronUp, GitBranch, User } from 'lucide-react';
import { IADVisual } from './IADVisuals';

const STATUS_NOTE = { unstructured: 'El especialista respondió sin estructura; se muestra su resumen.', error: 'No se pudo ejecutar este IAD.' };

const SustentoLine = ({ it }) => (
  <div className="space-y-1 text-sm">
    <p className="text-slate-300"><span className="font-semibold text-slate-100">Problema detectado:</span> {it.problem_detected || '—'}</p>
    <p className="text-slate-300"><span className="font-semibold text-slate-100">IAD utilizado:</span>{' '}
      <span className="font-mono text-amber-300" data-testid={`iad-item-code-${it.code}`}>{it.code}</span> · {it.name}</p>
    <p className="text-slate-300"><span className="font-semibold text-slate-100">Por qué:</span> {it.why || '—'}</p>
  </div>
);

const IADItem = ({ it, idx, compact }) => {
  const [open, setOpen] = useState(!compact);
  return (
    <div className="iad-reveal rounded-xl border border-slate-700/70 bg-slate-900/40 p-4" style={{ animationDelay: `${idx * 90}ms` }} data-testid={`iad-item-${it.code}`}>
      <div className="flex items-start justify-between gap-4">
        <SustentoLine it={it} />
        <button type="button" onClick={() => setOpen((o) => !o)} className="shrink-0 rounded-md p-1 text-slate-400 transition-colors duration-150 hover:bg-slate-700/50 hover:text-white" data-testid={`iad-item-toggle-${it.code}`}>
          {open ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
        </button>
      </div>
      <div className="mt-2 flex flex-wrap gap-2 text-[11px]">
        <span className="inline-flex items-center gap-1 rounded-full border border-sky-500/30 px-2 py-0.5 text-sky-300"><GitBranch className="h-3 w-3" />{it.gov}</span>
        <span className="inline-flex items-center gap-1 rounded-full border border-slate-600 px-2 py-0.5 text-slate-300"><User className="h-3 w-3" />{it.agent_name}</span>
        {it.family && <span className="rounded-full border border-slate-600 px-2 py-0.5 text-slate-400">{it.family}</span>}
      </div>
      {open && (
        <div className="mt-4 space-y-3 border-t border-slate-700/60 pt-4">
          {STATUS_NOTE[it.status] && <p className="text-xs text-amber-300">{STATUS_NOTE[it.status]}</p>}
          {it.summary && <p className="text-sm leading-relaxed text-slate-200">{it.summary}</p>}
          <IADVisual type={it.visual_type} visual={it.visual} />
          {it.findings?.length > 0 && (
            <ul className="space-y-1 text-sm text-slate-300">{it.findings.map((f, i) => <li key={i}>› {f}</li>)}</ul>
          )}
        </div>
      )}
    </div>
  );
};

export const IADSustento = ({ analysis, compact = false }) => {
  const items = analysis?.items || [];
  if (!items.length) return null;
  return (
    <section className="iad-scope space-y-3 rounded-2xl border border-amber-400/25 bg-gradient-to-b from-amber-500/[0.06] to-transparent p-5" data-testid="iad-sustento">
      <div className="flex flex-wrap items-center gap-3">
        <BookOpenCheck className="h-5 w-5 text-amber-300" />
        <h3 className="text-sm font-bold uppercase tracking-[0.18em] text-amber-200">Sustento metodológico</h3>
        <span className="rounded-full bg-slate-800 px-2 py-0.5 text-[11px] text-slate-400" data-testid="iad-sustento-mode">
          {analysis.mode === 'manual' ? 'IAD elegido por el usuario' : 'IAD elegido por SUPER-100'}
        </span>
        {analysis.problem_type && <span className="text-xs text-slate-400">Tipo de problema: {analysis.problem_type}</span>}
      </div>
      {items.map((it, i) => <IADItem key={`${it.code}-${i}`} it={it} idx={i} compact={compact} />)}
    </section>
  );
};
